import React from 'react';
import {isFromAccountingTeam, isFromTechTeam} from '../../../auth/UserPermissions';
import Box from '@amzn/awsui-components-react/polaris/box';
import PermissionsModal from '../../PermissionsModal';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Header from '@amzn/awsui-components-react/polaris/header';
import Button from '@amzn/awsui-components-react/polaris/button';
import ButtonDropdown from '@amzn/awsui-components-react/polaris/button-dropdown';
import {TestingStatus} from '../model/TestingStatus';


export default function EditTestRequestModal(props) {
    const [hasAccess] = React.useState(isFromTechTeam() || isFromAccountingTeam());
    const [selectedId, setSelectedId] = React.useState(props.currentRequest.currentStatus);

    // FIXME - If status is changed to COMPLETE, then provide option to input the approver alias and another field for SIM link etc.

    const onSubmitButtonClick = (event: CustomEvent) => {
        event.preventDefault();

        // TODO - Call DDB to save a new item
        const sanitizedTestRequestName: string = selectedId.toLocaleString();
        console.log("Mocking interaction with DDB: " + sanitizedTestRequestName)

        props.setVisible(false);
    }

    const onCancelButtonClick = (event: CustomEvent) => {
        event.preventDefault();
        props.setVisible(false);
    }

    // FIXME - need to convert back and from correctly
    const onSelectionChange = (event: CustomEvent) => {
        event.preventDefault();

        const selection = event.detail.id;
        const status: TestingStatus = selection as TestingStatus;

        setSelectedId(status);
    }

    const isDropdownButtonDisabled = (chosenStatus: TestingStatus) => {
        return props.currentRequest.currentStatus === chosenStatus;
    }

    const isSubmitButtonDisabled = () => {
        return props.currentRequest.currentStatus === selectedId;
    }

    return (
        <Box color='inherit'>
            {!hasAccess && <PermissionsModal hasPageAccess={hasAccess}/>}
            {hasAccess && <SpaceBetween direction='vertical' size='xl'>
                <Modal
                    onDismiss={() => props.setVisible(false)}
                    visible={props.isVisible}
                    header={<Header description={"Change the current status of Test Request"}>
                        Update Test Request Status
                    </Header>}
                    footer={
                        <Box float="right">
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button variant="link" onClick={onCancelButtonClick}> Cancel </Button>
                                <Button variant="primary" onClick={onSubmitButtonClick} disabled={isSubmitButtonDisabled()}> Submit </Button>
                            </SpaceBetween>
                        </Box>
                    }
                >
                    <ButtonDropdown
                        items={[
                            { id: TestingStatus[TestingStatus.Complete], text: "Complete", disabled: isDropdownButtonDisabled(TestingStatus.Complete) },
                            { id: TestingStatus[TestingStatus.InProgress], text: "InProgress", disabled: isDropdownButtonDisabled(TestingStatus.InProgress) },
                            { id: TestingStatus[TestingStatus.Abandoned], text: "Abandoned", disabled: isDropdownButtonDisabled(TestingStatus.Abandoned) },
                        ]}
                        onItemClick={onSelectionChange}
                    >
                        {selectedId}
                    </ButtonDropdown>
                </Modal>
            </SpaceBetween>}
        </Box>
    );
}
